import React from 'react'
import Layout from './layout'
import SEO from './seo'
import Button from './button'

const PageComponent = ({
  colors,
  description,
  links,
  lang,
  logo,
  rounded,
  title
}) => (
  <Layout colors={colors} logo={logo} title={title}>
    <SEO description={description} lang={lang} title={title} />
    <ul className="grid gap-4">
      {links.map((link, i) => (
        <li key={i}>
          <Button
            colors={colors}
            label={link.label}
            rounded={rounded}
            url={link.url}
          />
        </li>
      ))}
    </ul>
  </Layout>
)

export default PageComponent
